<template>
  <div class="w-100">
    <div
      class="w-100 table-body d-flex align-items-center justify-content-between"
    >
      <h5 class="mb-0 body-title">Finance Costs</h5>
      <h5 class="body-title mb-0">
        <b>{{ NumberFormatter(finance_costs($route)) }}</b>
      </h5>
    </div>
    <ClickableInputWithPopUp
      name="Interest Expense"
      bg-color="gray"
      :sub="false"
      model-name="interest_expense"
    />
    <EditableSheet
      v-if="$route.query.business !== 'master'"
      data-key="additional_finance_cost"
    />
    <CustomClickableInput
      v-else
      v-model="groupData['additional_finance_cost']"
      :disabled="true"
      name="Additional Finance Cost"
    />
    <div class="header d-flex align-items-center w-100 justify-content-between">
      <p class="header-title mb-0">Earning before Tax (EBT)</p>
      <p class="header-title mb-0">
        {{ NumberFormatter(earningBeforeTax($route)) }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useNoneIFRSProfitLoss } from "../../../../../store/NonIFRS/profitLoss.store";
import { NumberFormatter } from "../../../../../helpers/numberFormatter";
import ClickableInputWithPopUp from "./InputWithPop.vue";
import EditableSheet from "../common/EditableSheet.vue";
import { CustomClickableInput } from "../../../../common";

const nonIfrsPlStore = useNoneIFRSProfitLoss();
const { finance_costs, earningBeforeTax, groupData } =
  storeToRefs(nonIfrsPlStore);
</script>

<style scoped>
.header {
  min-height: 44px;
  background: #0f75bc;
  padding-right: 100px;
  padding-left: 10px;
}

.header-title {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.055em;
  color: #fafbff;
}

.table-body {
  min-height: 44px;
  padding-right: 100px;
  padding-left: 26px;
}

.body-title {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.055em;
  color: #382628;
}

.white {
  background: #fafbff;
}

.gray {
  background: #deeded;
}

.table-body.sub {
  padding-left: 46px;
}
.total-container {
  min-height: 76px;
  border-top: 1px solid #747171;
  background: #fafbff;
  padding-right: 100px;
  padding-left: 10px;
}
.total-amount {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  color: #000000;
}
.grand-total {
  height: 75px;
  background: #0f75bc;
  padding-right: 100px;
  padding-left: 10px;
}
.grand-total-amount {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.055em;
  text-transform: uppercase;
  color: #fafbff;
}
.white {
  background: #fafbff;
}

.gray {
  background: #deeded;
}
</style>
